<template>
  <div
    itemprop="review"
    itemscope
    itemtype="https://schema.org/Review">
    <template v-if="reviews && reviews.items && reviews.items.length != 0">
      <div class="table clearfix">
        <div
          v-if="showTableHead"
          class="table-head">
          <div
            v-if="showId"
            class="table-col table-col-id">
            <span>ID</span>
          </div>
          <div
            v-if="showOrderId"
            class="table-col table-col-order-id">
            <span>ID заказа</span>
          </div>
          <div class="table-col table-col-rating">
            <span>Оценка</span>
          </div>
          <div
            v-if="showBuyer"
            class="table-col table-col-buyer">
            <span>Покупатель</span>
          </div>
          <div class="col table-col table-col-text">
            <span>Отзыв</span>
          </div>
          <div class="table-col table-col-options"/>
        </div>
        <div
          v-for="(item, index) in reviews.items"
          :key="index"
          class="table-line">
          <div
            v-if="showId"
            class="table-col table-col-id">
            <span>{{ item.id }}</span>
          </div>
          <div
            v-if="showOrderId"
            class="table-col table-col-order-id">
            <span>{{ item.order_id }}</span>
          </div>
          <div class="table-col table-col-rating">
            <rating
              itemprop="reviewRating"
              itemscope
              itemtype="https://schema.org/Rating"
              :value="item.rating ? item.rating.toString() : null"
              :show-reviews="showReviewsCount"/>
          </div>
          <div
            v-if="showBuyer"
            class="table-col table-col-buyer">
            <div
              v-if="item.is_external == 1"
              class="review-buyer user">
              <user
                :id="0"
                :key="index + item.external.author_name"
                :avatar="''"
                :name="item.external.author_name"
                :role="'(Покупатель)'"
                :status="false"
                class="col-md-3 user"/>
            </div>
            <div
              v-else
              class="review-buyer">
              <user
                v-if="item.buyer"
                :id="parseInt(item.buyer.id ? item.buyer.id : 0)"
                :key="index + item.buyer.username"
                :avatar="
                  item.buyer.photo != '' ? backendUrl + item.buyer.photo : ''
                "
                :name="item.buyer.username"
                :role="'(Покупатель)'"
                :status="
                  item.buyer.online && parseInt(item.buyer.online) == 1
                    ? true
                    : false
                "
                class="col-md-3"/>
            </div>
          </div>
          <div
            v-if="showPrice"
            class="col table-col table-col-text">
            <div>
              <div
                v-if="item.is_external == 1 && item.external"
                itemprop="name">
                {{ item.external.game.name_en }}
                {{
                  item.external.service ? "/ " + item.external.service : ""
                }}
                ({{ item.external.price }} руб.)
                <span
                  class="created-at"
                  itemprop="datePublished">
                  {{ item.external.created_at }}
                </span>
              </div>
              <div
                v-else
                itemprop="name">
                {{ item.order ? item.order.game.name_en : "" }}
                {{
                  item.order
                    ? item.order.category.name
                      ? "/ " + item.order.category.name
                      : ""
                    : ""
                }}
                ({{ item.order ? item.order.price : "" }} руб.)
                <span
                  class="created-at"
                  itemprop="datePublished">
                  {{ item.created_at }}
                </span>
              </div>
              <i
                v-if="!item.text || item.text.trim().length == 0"
                itemprop="reviewBody">
                Текст отзыва отсутствует
              </i>
              <div
                v-else
                itemprop="reviewBody"
                class="review-text">
                {{ item.text }}
              </div>
            </div>
          </div>
          <div
            v-else
            class="col table-col table-col-text">
            <div>
              <i
                v-if="!item.text || item.text.trim().length == 0">Текст отзыва отсутствует</i>{{ item.text }}
              <div v-if="item.is_external == 1 && item.external">
                {{ item.external.created_at }}
              </div>
              <div v-else>
                {{ item.created_at }}
              </div>
            </div>
          </div>
          <div
            v-if="
              item.is_external == 1 &&
                (isAdmin || (user && user.jti == item.to_user_id)) &&
                showEdit
            "
            class="table-col table-col-options">
            <div class="table-edit">
              <b-dropdown
                right
                no-caret
                variant="link"
                class="table-options"
                toggle-class="text-decoration-none table-options-trigger">
                <template slot="button-content">
                  <svgicon
                    name="edit"
                    width="13"
                    height="3"
                    class="icon-options"/>
                </template>
                <b-dropdown-header>Настройки</b-dropdown-header>
                <template>
                  <b-dropdown-item @click="openAddReviewModal(item)">
                    <template v-if="item.is_external == 1">
                      <editModalReview
                        :id="'editModalReview' + item.id"
                        :key="item.id"
                        :external="item"
                        :user-id="userId"
                        :reviews="reviews"
                        :games="games"
                        :reviews-sources="reviewsSources"
                        :update-entity="updateEntity"/>
                    </template>
                    <span class="table-options-icon">
                      <svgicon
                        name="edit-pen"
                        width="14"
                        height="14"
                        class="icon-edit-pen"/>
                    </span>
                    Редактировать
                  </b-dropdown-item>
                </template>
              </b-dropdown>
            </div>
          </div>
        </div>
      </div>
      <template>
        <pagination
          v-if="reviews && reviews._meta.pageCount > 1"
          :page-count="reviews._meta.pageCount"
          path="reviewsPage"
          :current-page="reviews._meta.currentPage"
          class="reviews -pagination"/>
      </template>
    </template>
    <template v-else>
      <noItems
        sub-message="У пользователя еще нет ни одного отзыва"
        message="Нет отзывов"/>
    </template>
  </div>
</template>

<script>
import "~/icons/edit-pen.js";
import "~/icons/edit.js";
import pagination from "~/components/base/pagination.vue";
import rating from "~/components/base/rating.vue";
import editModalReview from "~/components/modals/uploadReview.vue";
import noItems from "~/components/tables/noItems.vue";
import user from "~/components/base/user.vue";
import { mapState, mapGetters, mapMutations } from "vuex";
export default {
  components: {
    rating,
    noItems,
    editModalReview,
    pagination,
    user,
  },
  props: {
    reviews: {
      type: Object,
      default: () => ({}),
    },
    userId: {
      type: Number,
      default: null,
    },
    showOrderId: {
      type: Boolean,
      default: true,
    },
    showId: {
      type: Boolean,
      default: true,
    },
    showBuyer: {
      type: Boolean,
      default: false,
    },
    updateEntity: {
      type: Boolean,
      default: false,
    },
    showTableHead: {
      type: Boolean,
      default: true,
    },
    showEdit: {
      type: Boolean,
      default: true,
    },
    showReviewsCount: {
      type: Boolean,
      default: true,
    },
    showPrice: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      backendUrl: process.env.backendUrl,
      games: null,
      reviewsSources: null,
    };
  },
  computed: {
    isAdmin() {
      if (this.$store.state.auth) {
        if (
          this.$store.state.auth.user &&
          this.$store.state.auth.user.role == 1
        ) {
          return true;
        }
      }
      return false;
    },
    ...mapGetters({
      user: "auth/getUser",
    }),
  },
  mounted() {
    if (this.user) {
      this.$store
        .dispatch("newOffer/GET_GAMES")
        .then((response) => {
          if (!response) {
            this.$noty.error("Не удалось получить список игр.");
          } else {
            this.games = response;
          }
        })
        .catch((exception) => {
          this.$noty.error("Не удалось получить список игр.");
        });

      this.$store
        .dispatch("reviews/GET_REVIEWS_SOURCES")
        .then((response) => {
          if (!response.success) {
            this.$noty.error("Не удалось получить список источников.");
          } else {
            this.reviewsSources = response.data;
          }
        })
        .catch((exception) => {
          this.$noty.error("Не удалось получить список источников.");
        });
    }
  },
  methods: {
    openAddReviewModal(review) {
      this.$bvModal.show("editModalReview" + review.id);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/design/site/tables.scss";
.table-line {
  float: left;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding-left: 22px;
  padding-right: 22px;
  border-bottom: 1px solid #eff1f4;
  &:last-child {
    border-bottom: 0;
  }
}
.table-col {
  float: left;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  padding: 17px 10px 13px;
  min-height: 48px;
  color: #a8aaaf;
}

.table-col-id {
  width: 100px;
}
.table-col-order-id {
  width: 120px;
}
.table-col-rating {
  width: 110px;
}

.table-head {
  display: flex;
  padding-right: 32px;
  padding-left: 32px;
}

.table-col-buyer {
  width: 240px;
}
.table-col-options {
  width: 120px;
}

.review-text {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: #2d303a;
}

.created-at{
  margin-left: 16px;
}
</style>
